import { getText } from '../../utils';
var status = function status(node, schema) {
  return node.attrs.text ? "[ ".concat(node.attrs.text.toUpperCase(), " ]") : getText(node);
};
export default status;